import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import classNames from 'classnames';
import { stringify } from 'querystring';

import { ERefsApps } from '@enums';

import { Translate } from '@decorators';

import { getConfig } from '@base/constants';
import { isMobileScreen } from '@base/utils';

import { AppInstalls, ButtonDefault, Rating } from '@components';

import { IAppHeaderProps } from './types';

import * as s from './AppHeader.scss';

@Translate('components.AppSeoPage.AppHeader')
export class AppHeaderComponent extends React.Component<IAppHeaderProps & RouteComponentProps> {

	onLaunchButtonClick = () => {
		const loginQuery = {
			'app_id': this.props.appId,
			'page': `${location.origin}${this.props.location.pathname}`,
			'ref': ERefsApps.SEO_GAMES,
		};

		window.location.href = `${window.location.origin}?${stringify(loginQuery)}`;
	};

	render() {
		const {
			className,
			title,
			rating,
			voters,
			installs,
			isMyCreated,
			isFake,
			onLaunchButtonClick,
		} = this.props;

		return (
			<div className={classNames(className, s.block, { [s.blockFake]: isFake })}>
				<div className={s.info}>
					<h1 className={s.title}>{title}</h1>
					<div className={s.statWrapper}>
						<Rating className={s.statRating} rating={rating} voters={voters}/>
						<AppInstalls className={s.statInstalls} installs={installs}/>
					</div>
				</div>
				<div className={s.buttonWrapper}>
					<ButtonDefault
						className={s.button}
						isFullWidth
						onClick={onLaunchButtonClick}
					>
						{this.t('launch')}
					</ButtonDefault>
				</div>
				{!isMyCreated && (isMobileScreen() && getConfig().isTwa && !!getConfig().createMyWarning) &&
					<div className={s.warning}>
						<span className={s.warningText}>{getConfig().createMyWarning}</span>
					</div>
				}
			</div>
		);
	}

}

export const AppHeader = withRouter(AppHeaderComponent);
